
'use client';

import { Box, Grid, Typography, Button } from '@mui/material';
import { useTranslations } from 'next-intl';

const FooterOfService = () => {
    const t = useTranslations("ServicePage.footer_of_service");
    return (
        <Box sx={{ py: 10, backgroundColor: "#132c4b", color: "white" }}>
            <Grid container sx={{ maxWidth: "lg", margin: "auto", px: 2.5 }}>
                <Grid size={12} sx={{ textAlign: "center" }}>
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            mb: 3,
                        }}
                    >
                        {t('title')}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#e2e8f0',
                            mb: 6,
                            maxWidth: 'md',
                            mx: 'auto'
                        }}
                    >
                        {t('description')}
                    </Typography>
                    <div className="flex justify-center gap-4 flex-col sm:flex-row">
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                backgroundColor: '#F15859',
                                fontWeight: 'bold',
                                px: 6,
                                py: 1.5,
                                fontSize: '1rem',
                                borderRadius: '10px',
                                boxShadow: '0 4px 14px 0 rgba(225, 29, 72, 0.39)',
                                '&:hover': {
                                    backgroundColor: '#be123c'
                                }
                            }}
                            href="/contact"
                        >
                            {t('button')}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}

export default FooterOfService;